import useIdentity from "@/features/ui/hooks/use-identity";
import useGetMySelf from "@/features/auth/use-get-my-self";
import { companyTypeRequestFormatConverter } from "@/utils/converter";

const useCompanyIdentity = () => {
  const identity = useIdentity();
  const { data } = useGetMySelf();
  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  // 회사명은 JWT에 없어 /users 응답(companies)에서 찾는다 (SWR 캐시라 추가 요청 없음)
  const companyName = data?.companies.find(
    (company) => company.id === companyId
  )?.name;

  return { companyId, companyType, companyName };
};

export default useCompanyIdentity;
